var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-export") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STENI-pattern-generator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "choose-product-menu-open-pre",
    transform: "translate(-743.000000, -445.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(698.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-export",
    transform: "translate(46.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    points: "20 6.66666667 20 -4.54747351e-13 13.3333333 -4.54747351e-13"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    points: "6.66666667 0 0 0 0 20 20 20 20 13.3333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1666667,0.833333333 L10,9.16666667",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.b9a92e605a6c3249dc932cc1e70ecf28.svg";
export { ForwardRef as ReactComponent };